export const fi = {
  sign_in_title: 'ASF-lämpökartta',
  sign_in_button: 'Kirjaudu sisään Google-tilillä',
  sign_in_failed: 'Kirjautuminen epäonnistui. Yritä uudelleen.',
  no_access_title: 'Ei käyttöoikeutta',
  no_access_body:
    'Tunnuksellasi ei ole käyttöoikeutta tähän karttaan. Ota yhteyttä ylläpitoon.',
  sign_out: 'Kirjaudu ulos',
  updating: 'Päivitetään, odota hetki…',
  still_processing: 'Päivitys kestää tavallista kauemmin.',
  heatmap_unavailable: 'Lämpökarttaa ei voitu päivittää.',
  error_title: 'Karttaa ei voitu ladata',
  retry: 'Yritä uudelleen',
  settings: 'Asetukset',
  close: 'Sulje',
  refresh_data: 'Päivitä kartta',
  show_borders: 'Näytä aluerajat',
  show_sub_area: 'Näytä {{name}}',
  heatmap_opacity: 'Lämpökartan peittävyys',
  unnamed_area: '(nimetön alue)',
  area_coverage_label: '{{name}}: {{value}}',
  area_status: '{{name}}: {{status}}',
} as const
